'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formatPropTypes = require('react-jplayer/lib/util/formatPropTypes');

var _formatPropTypes2 = _interopRequireDefault(_formatPropTypes);

var _playlistItemContainer = require('../playlistItem/playlistItemContainer');

var _playlistItemContainer2 = _interopRequireDefault(_playlistItemContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Playlist = function Playlist(_ref) {
  var playlist = _ref.playlist,
      children = _ref.children,
      attributes = _ref.attributes;
  return _react2.default.createElement(
    'ul',
    attributes,
    playlist.map(function (media, index) {
      return _react2.default.createElement(
        _playlistItemContainer2.default,
        { key: media.id, index: index },
        children
      );
    })
  );
};

Playlist.propTypes = {
  attributes: _propTypes2.default.object.isRequired,
  playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string,
    artist: _propTypes2.default.string,
    sources: _propTypes2.default.shape(_formatPropTypes2.default).isRequired,
    poster: _propTypes2.default.string,
    id: _propTypes2.default.string.isRequired,
    free: _propTypes2.default.bool
  })).isRequired,
  children: _propTypes2.default.node.isRequired
};

exports.default = Playlist;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplaylist/lib/components/playlist/playlist.js
// module id = 830
// module chunks = 0